import { useState, useEffect } from 'react';
import { Prompt, useHistory } from 'react-router-dom';
import { useOpenUnsavedChangesModal } from 'seagull';
import { jsx as _jsx } from "react/jsx-runtime";
const compareLocation = (locationA, locationB) => {
  return locationA.pathname === locationB.pathname && locationA.search === locationB.search && locationA.hash === locationB.hash;
};
export function NavigationGuardModal(_ref) {
  let {
    when,
    primaryButtonTestId,
    secondaryButtonTestId
  } = _ref;
  const openUnsavedChangesModal = useOpenUnsavedChangesModal();
  const history = useHistory();
  const [lastNavigation, setLastNaviation] = useState(null);
  useEffect(() => {
    if (lastNavigation) history.push(lastNavigation);
  }, [lastNavigation]);
  return /*#__PURE__*/_jsx(Prompt, {
    when: when,
    message: nextLocation => {
      if (lastNavigation && compareLocation(lastNavigation, nextLocation)) {
        return true;
      } else {
        openUnsavedChangesModal({
          primaryButtonTestId,
          secondaryButtonTestId
        }).then(confirmedNavigation => {
          if (confirmedNavigation) {
            setLastNaviation(nextLocation);
          }
        });
        return false;
      }
    }
  });
}